import { ProductFeeType } from '@shared/constants';
import { ProductFeeStructure, RateType } from '@shared/models';
import { ProductUploadWarning } from './product-upload-additional-result';

export enum AsantoColumnType {
  String = 'string',
  Number = 'number',
  NumberWithUnits = 'numberWithUnits',
  Boolean = 'boolean',
  Date = 'date',
}

export interface UploadedProductsResult {
  products: Record<string, unknown>[];
  warnings: string[];
  additionalFileProcessingResult: {
    variableRateScheduleStartDate: Date | null;
    hasMissingVariableRateCodes: boolean;
    requiredVariableRateCodes: string[];
    productSheetVariableRateCodes: {
      code: string;
      description: string;
      rate: number;
      isTracker: boolean;
    }[];
    variableRateWarnings: ProductUploadWarning[];
  };
}

export interface ResiBtlProductFee {
  value: number;
  type: ProductFeeType;
  structure: ProductFeeStructure;
}

export interface ResiBtlProductRate {
  initialPeriod: number | null;
  ordinal: number;
  rate: number | null;
  rateType: RateType | null;
  until: string | null;
  variableRate: number | null;
  variableRateCode: string | null;
}
